import {
    postFindByCondition,
    postCreateUser,
    putUserById,
    deleteUserById
} from "./api/user"

class UserService {
    async findByCondition(page, itemsPerPage){
        var data = { 
            query_data:{
                type: 'all',
                query_options: [],
                pagination:{
                    itemsPerPage: itemsPerPage
                }
            }
        };

        return await postFindByCondition(page, data);
    }

    async createUser(data){
        var userData = this.mapUserData(data);
        return await postCreateUser(userData);
    }

    mapUserData(data){
        return {
            user: {
                name: data.user_name,
                email: data.user_account,
                password: data.password,
                role: data.role,
                salesmans: data.salesmans
            }
        }
    }

    async updateUser(data){
        var userData = this.mapUserData(data);
        return await putUserById(data.id,userData);
    }

    async deleteUser(id){
        return await deleteUserById(id);
    }
}

export default new UserService();